<app-address [type]="'Student'" [filterTypes]="['Current Address','Mailing Address']" 
	[data]="partyContactMechanisms"
	[initialCoeRelatedStudents]="coeRelatedStudents" [partyId]="partyId" [editing]="editing"
	(partyContactMechanismsChange)="pcmNotificationChange($event,'Address')">
</app-address>

<app-phone [type]="'Student'" [filterTypes]="['Current Address Phone', 'Mailing Address Phone']"
	[data]="partyContactMechanisms" [initialCoeRelatedStudents]="coeRelatedStudents" [partyId]="partyId"
	[editing]="editing" (partyContactMechanismsChange)="pcmNotificationChange($event,'Phone')">
</app-phone>


<div class="row" style="padding-top: 5px;">
	<div class="col-8" *ngIf="msg!=null && msg.MSG!" class="theme-font-color">
		<app-msg [msg]="msg"></app-msg>
	</div>

	<div class="col text-end">
		<button mat-raised-button color="primary" type="submit" (click)="save()" [disabled]="isDisabled()">
			Save
			<mat-icon  *ngIf="isSaving">
				<mat-spinner color="warn" diameter="18"> </mat-spinner>
			</mat-icon>
		</button>
		<button mat-raised-button color="accent" (click)="reset()"> Reset</button>
	</div>
</div>
